// OfferTable.tsx - Version corrigée
import * as React from 'react';
import * as ReactTable from "react-table";
import { CSSProperties } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import * as OfferStore from '../store/Offer';
import Table from "./Table";
import * as Styles from '../styles/baseStyle';
import { getText } from '../utils/texts';
import * as _ from 'lodash';
import { createSelector } from 'reselect';
import { canUpdate } from '../security/roles';
import { ProductNameCell } from './OfferTableProductNameCell';
import { OfferTableCell } from './OfferTableCell';

interface OfferTableOwnProps {
    isDarkMode: boolean;
}

interface OfferTableConnectedProps {
    productIds: number[];  // ← CORRIGÉ: number[] au lieu de string[]
    promotions: any;
    disabled: boolean;
}

type OfferTableProps = OfferTableOwnProps & OfferTableConnectedProps;

class OfferTable extends React.PureComponent<OfferTableProps> {
    private memoizedColumns: Array<any> | null = null;
    private lastPromotionsHash: string = '';

    getColumns = () => {
        const currentHash = JSON.stringify(Object.keys(this.props.promotions));

        if (this.memoizedColumns && this.lastPromotionsHash === currentHash) {
            return this.memoizedColumns;
        }

        this.lastPromotionsHash = currentHash;

        const nameColumn = {
            id: "name",
            Header: <div style={{ lineHeight: '65px', width: '-webkit-fill-available' }}>
                <strong>{getText("OfferName")}</strong>
            </div>,
            accessor: d => d,
            Cell: (row) => <ProductNameCell productId={row.value} />,
            style: {
                width: '-webkit-fill-available',
                pointerEvents: this.props.disabled ? "none" : "initial",
                opacity: this.props.disabled ? 0.7 : 1,
                textAlign: 'left',
                lineHeight: '31px'
            } as CSSProperties,
        };

        const promotionColumns = _.values(this.props.promotions).map((promotion) => ({
            id: `promotion-${promotion.promotionId}`,
            Header: (
                <div>
                    <div style={{
                        padding: '2%',
                        height: 34,
                        borderBottom: this.props.isDarkMode
                            ? '1px solid transparent'
                            : '1px solid rgba(255, 255, 255, 0.16)'
                    }}>
                        <strong>{promotion.name}</strong>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ margin: 'auto' }}>{getText("OfferPromoRate")}</div>
                        <div style={{ margin: 'auto' }}>{getText("OfferUntil")}</div>
                    </div>
                </div>
            ),
            accessor: d => d,
            Cell: (row) => (
                <OfferTableCell
                    productId={row.value}
                    promotionId={promotion.promotionId}
                />
            ),
            style: {
                pointerEvents: this.props.disabled ? "none" : "initial",
                opacity: this.props.disabled ? 0.7 : 1,
                height: "100%",
                overflow: "visible"
            } as CSSProperties
        }));

        this.memoizedColumns = [nameColumn, ...promotionColumns] as any[];

        return this.memoizedColumns;
    }

    render() {
        const pageSize = Math.max(this.props.productIds.length, 12);

        return (
            <div className="offer-table card selectors borderSelectors"
                style={{ ...Styles.cardStyle, margin: "0 1%", height: "80%" }}>
                <Table
                    tableKey="offerPromo"
                    style={{ fontSize: 11, overflow: "hidden", height: '100%' }}
                    columns={this.getColumns()}
                    pageSize={pageSize}
                    showPageSizeOptions={false}
                    showPagination={false}
                    showPaginationBottom={false}
                    data={this.props.productIds}
                />
            </div>
        );
    }
}

// Selector for product IDs only
const productIdsSelector = createSelector(
    [OfferStore.productPromoFilteredSelector],
    (products) => products.map(p => p.storeItemId)
);

const mapStateToProps = (state: ApplicationState) => ({
    productIds: productIdsSelector(state),
    promotions: state.seed.seed.promotions,
    disabled: !canUpdate(state)
});

export default connect(mapStateToProps)(OfferTable);